import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PRODUCT_FEATURE_KEY, State, productAdapter } from './product.reducer';

export const selectState = createFeatureSelector<State>(PRODUCT_FEATURE_KEY);

export const selectLoading = createSelector(
  selectState,
  (state: State) => state.loading
);

export const selectLoadingCategories = createSelector(
  selectState,
  (state: State) => state.loadingCategories
);

export const selectCategories = createSelector(
  selectState,
  (state: State) => state.categories
);

export const selectSelectedProductId = createSelector(
  selectState,
  (state: State) => state.selectedProductId
);

export const selectError = createSelector(
  selectState,
  (state: State) => state.error
);

export const selectProducts = createSelector(selectState, (state: State) =>
  productAdapter.getSelectors().selectAll(state)
);

export const selectProductEntities = createSelector(
  selectState,
  (state: State) => productAdapter.getSelectors().selectEntities(state)
);

export const selectSelectedProduct = createSelector(
  selectState,
  selectSelectedProductId,
  (state: State, selectedId: string | null) =>
    selectedId ? state.entities[selectedId] : null
);

export const selectVariants = createSelector(
  selectState,
  (state: State) => state.variants
);

export const selectLoadingVariants = createSelector(
  selectState,
  (state: State) => state.loadingVariants
);

export const selectVariantsError = createSelector(
  selectState,
  (state: State) => state.variantsError
);
